const MIN_MS = 1200;
const MAX_MS = 1800;
const REDUCED_MS = 400;

export function initPageLoader() {
  const root = document.documentElement;
  const loader = document.getElementById("page-loader");
  if (!loader) {
    root.classList.remove("is-loading");
    return;
  }

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const started = performance.now();
  let hidden = false;

  const hide = () => {
    if (hidden) return;
    hidden = true;
    const wait = Math.max(0, (reduced ? REDUCED_MS : MIN_MS) - (performance.now() - started));
    window.setTimeout(() => {
      root.classList.remove("is-loading");
      root.classList.add("is-ready");
      loader.setAttribute("aria-hidden", "true");
    }, wait);
  };

  if (document.readyState === "complete") hide();
  else window.addEventListener("load", hide, { once: true });
  window.setTimeout(hide, reduced ? REDUCED_MS + 200 : MAX_MS);

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      hidden = true;
      root.classList.remove("is-loading");
      root.classList.add("is-ready");
    }
  });

  document.addEventListener("click", (event) => {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.button !== 0) return;
    const link = event.target.closest("a[href]");
    if (!link) return;
    if (link.target === "_blank" || link.hasAttribute("download")) return;
    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch {
      return;
    }
    if (url.origin !== window.location.origin) return;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return;

    event.preventDefault();
    hidden = true;
    root.classList.add("is-loading");
    root.classList.remove("is-ready");
    loader.removeAttribute("aria-hidden");
    window.setTimeout(() => {
      window.location.href = url.href;
    }, 80);
  });
}
